export class VideoPlayer {
  constructor(videoContainer) {
      this.videoContainer = videoContainer;
      this.video = videoContainer.querySelector('video');

      if (this.video) {
          this.videoContainer.addEventListener("click", (event) => {
              event.preventDefault();

              if (this.video.paused) {
                  this.video.play();
              } else {
                  this.video.pause();
              }
          });

          this.video.addEventListener("pause", () => {
              this.videoContainer.classList.remove("playing");
          });

          this.video.addEventListener("play", () => {
              this.videoContainer.classList.add("playing");
          });
      }
  }
}
